<template>
  <div style="display: flex; align-items: center">
    <span style="margin-right: 10px; width: 100px"> {{ i18nJS.date_label }} </span>
    <!-- usare v-select2 con :selectConfig così non va bene -->
    <datepicker :value="now()" @input="selectRequirement($event)"></datepicker>
  </div>
</template>

<script>
import apiConnector from '@/epersonam/apiConnector';
import datepicker from '../../datepicker';

export default {
  name: 'dateRequirement',
  props: ['buId', 'index', 'params'],
  components: {
    datepicker,
  },
  data() {
    return {};
  },
  mounted() {
    this.$emit('selected', { data_selected: this.now(), index: this.index });
  },
  computed: {
    i18nJS() {
      return window.i18nJS;
    },
  },
  methods: {
    now() {
      return moment().format(i18nJS.time.formats.date_only);
    },
    selectRequirement(e) {
      this.$emit('selected', { data_selected: e, index: this.index });
    },
  },
};
</script>

<style lang="scss" scoped></style>
